import type { GlossaryDefinition } from '@/lib/glossary/types'

export type PanelState = { status: 'loading' | 'error'; label: string } | { status: 'ready'; term: GlossaryDefinition }

const definitions = new Map<string, GlossaryDefinition>()

export const createDefinitionLoader = (setState: (state: PanelState) => void) => {
  let request: AbortController | null = null
  const abort = () => request?.abort()
  const load = async (button: HTMLButtonElement) => {
    abort()
    const controller = new AbortController()
    request = controller
    const key = button.dataset.glossary ?? ''
    const label = button.textContent ?? key
    const cached = definitions.get(key)
    setState(cached ? { status: 'ready', term: cached } : { status: 'loading', label })
    if (cached) {
      return
    }
    try {
      const response = await fetch(`/api/glossary/${encodeURIComponent(key)}`, { signal: controller.signal })
      if (!response.ok) {
        throw new Error(`Glossary: ${response.status}`)
      }
      const term: GlossaryDefinition = await response.json()
      if (!controller.signal.aborted) {
        definitions.set(key, term)
        setState({ status: 'ready', term })
      }
    } catch {
      if (!controller.signal.aborted) {
        setState({ status: 'error', label })
      }
    }
  }
  return { load, abort }
}
